var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0675 2.88262C9.85452 2.67552 9.50916 2.67552 9.29615 2.88262L4.93251 7.12504C4.83022 7.22449 4.77275 7.35938 4.77275 7.50002C4.77275 7.64067 4.83022 7.77555 4.93251 7.875L9.29615 12.1174C9.50916 12.3245 9.85452 12.3245 10.0675 12.1174C10.2805 11.9103 10.2805 11.5746 10.0675 11.3675L6.08959 7.50002L10.0675 3.63258C10.2805 3.42548 10.2805 3.08971 10.0675 2.88262Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowDark);
export default __webpack_public_path__ + "static/media/left-arrow-dark.25827a74a296d5234edd26451003dbcc.svg";
export { ForwardRef as ReactComponent };